import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bool, func, string } from 'prop-types';
import { UTButton } from '@widergy/energy-ui';

import { formTypePropType, actionCreators as userFormActions } from '../../../redux/userFormHandlers';
import UTModal from '../UTModal';
import { message } from '../../../utils/stringUtils';

import FormCategoriesList from './components/FormCategoriesList';

class UserFormCreatorContainer extends PureComponent {
  state = { creationModalActive: false };

  componentDidMount = () => {
    this.props.dispatch(userFormActions.clearForm);
    if (this.props.modalOpened && this.props.hideCreateButton) {
      this.setState({ creationModalActive: true });
    }
    if (this.isSingleFormPropChecking(this.props)) {
      this.handleFormCategorySelected(this.props[`${this.props.formType}Categories`][0].forms[0].id);
    }
  };

  isSingleFormPropChecking = props =>
    props[`${this.props.formType}Categories`] &&
    props[`${this.props.formType}Categories`].length === 1 &&
    props[`${this.props.formType}Categories`][0].forms.length === 1;

  handleFormCategorySelected = id => {
    this.props.handleFormSelected(id);
    this.setState({ creationModalActive: false });
  };

  handleCreatePressed = () => {
    if (this.isSingleFormPropChecking(this.props)) {
      this.props.handleFormSelected(this.props[`${this.props.formType}Categories`][0].forms[0].id);
    } else {
      this.setState({ creationModalActive: true });
    }
  };

  handleModalClose = () => {
    if (this.props.onModalClose) this.props.onModalClose();
    this.setState({ creationModalActive: false });
  };

  render() {
    const cancelButton = {
      text: message(`Commons:back`),
      onPress: this.handleModalClose
    };
    return (
      <div>
        {!this.props.hideCreateButton && (
          <UTButton onPress={this.handleCreatePressed}>
            {this.props.createButtonText || message(`FormCreator:${this.props.formType}Init`)}
          </UTButton>
        )}
        {!this.props[`${this.props.formType}CategoriesLoading`] && (
          <UTModal
            isOpen={this.state.creationModalActive}
            onRequestClose={this.handleModalClose}
            title={message(`FormCreator:${this.props.formType}Init`)}
            contentLabel={this.props.formType}
            cancelButton={cancelButton}
          >
            <FormCategoriesList
              categories={this.props[`${this.props.formType}Categories`]}
              loading={this.props[`${this.props.formType}CategoriesLoading`]}
              listTitle={message(`FormCreator:${this.props.formType}Categories`)}
              onCategorySelected={this.handleFormCategorySelected}
            />
          </UTModal>
        )}
      </div>
    );
  }
}

const mapStateToProps = store => ({
  claimCategories: store.userForm.claimFormCategories,
  claimCategoriesLoading: store.userForm.claimFormCategoriesLoading,
  procedureCategories: store.userForm.procedureFormCategories,
  procedureCategoriesLoading: store.userForm.procedureFormCategoriesLoading
});

UserFormCreatorContainer.propTypes = {
  formType: formTypePropType,
  handleFormSelected: func.isRequired,
  onModalClose: func,
  createButtonText: string,
  modalOpened: bool,
  hideCreateButton: bool
};

export default connect(mapStateToProps)(UserFormCreatorContainer);
